// Matches old icon names from a icon id from E1
export const oldIconRegex = /^(fa3-icon|rjs[1-2]|vg-icon).*/;
